(function () {
	'use strict';

	var SUITS = ['♠', '♥', '♦', '♣'];
	var RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];

	function randInt(n) {
		var c = typeof window !== 'undefined' ? window.crypto : (typeof globalThis !== 'undefined' ? globalThis.crypto : null);
		if (c && c.getRandomValues) {
			var limit = Math.floor(4294967296 / n) * n;
			var x = new Uint32Array(1);
			do { c.getRandomValues(x); } while (x[0] >= limit);
			return x[0] % n;
		}
		return Math.floor(Math.random() * n);
	}

	function newDeck() {
		var deck = [];
		for (var s = 0; s < SUITS.length; s++) {
			for (var r = 0; r < RANKS.length; r++) {
				deck.push({ r: RANKS[r], s: SUITS[s] });
			}
		}
		for (var i = deck.length - 1; i > 0; i--) {
			var j = randInt(i + 1);
			var t = deck[i]; deck[i] = deck[j]; deck[j] = t;
		}
		return deck;
	}

	function cardValue(rank) {
		if (rank === 'A') return 11;
		if (rank === 'J' || rank === 'Q' || rank === 'K') return 10;
		return parseInt(rank, 10);
	}

	function total(cards) {
		var t = 0, aces = 0;
		for (var i = 0; i < cards.length; i++) {
			t += cardValue(cards[i].r);
			if (cards[i].r === 'A') aces++;
		}
		while (t > 21 && aces > 0) { t -= 10; aces--; }
		return t;
	}

	function isBlackjack(cards) {
		return cards.length === 2 && total(cards) === 21;
	}

	function dealerShouldHit(cards) {
		return total(cards) < 17;
	}

	function outcome(player, dealer) {
		var pb = isBlackjack(player), db = isBlackjack(dealer);
		if (pb || db) {
			if (pb && db) return 'push';
			return pb ? 'win' : 'lose';
		}
		var p = total(player), d = total(dealer);
		if (p > 21) return 'lose';
		if (d > 21) return 'win';
		if (p > d) return 'win';
		if (p < d) return 'lose';
		return 'push';
	}

	// Pip positions for 2-10 as [column 0..1, row 0..1] inside the pip area. Lower-half pips are turned upside down.
	var PIPS = {
		'2': [[.5, 0], [.5, 1]],
		'3': [[.5, 0], [.5, .5], [.5, 1]],
		'4': [[0, 0], [1, 0], [0, 1], [1, 1]],
		'5': [[0, 0], [1, 0], [.5, .5], [0, 1], [1, 1]],
		'6': [[0, 0], [1, 0], [0, .5], [1, .5], [0, 1], [1, 1]],
		'7': [[0, 0], [1, 0], [.5, .25], [0, .5], [1, .5], [0, 1], [1, 1]],
		'8': [[0, 0], [1, 0], [.5, .25], [0, .5], [1, .5], [.5, .75], [0, 1], [1, 1]],
		'9': [[0, 0], [1, 0], [0, 1 / 3], [1, 1 / 3], [.5, .5], [0, 2 / 3], [1, 2 / 3], [0, 1], [1, 1]],
		'10': [[0, 0], [1, 0], [.5, 1 / 6], [0, 1 / 3], [1, 1 / 3], [0, 2 / 3], [1, 2 / 3], [.5, 5 / 6], [0, 1], [1, 1]]
	};

	function cardHTML(card, compass) {
		var red = card.s === '♥' || card.s === '♦';
		var suit = card.s + '︎';
		var index = '<b>' + card.r + '</b><i>' + suit + '</i>';
		var body, i;

		if (card.r === 'A') {
			body = '<span class="nwg-card__ace">' + suit + '</span>';
		} else if (card.r === 'J' || card.r === 'Q' || card.r === 'K') {
			body = '<span class="nwg-card__court"><b>' + card.r + '</b></span>';
		} else {
			var pos = PIPS[card.r], pips = '';
			for (i = 0; i < pos.length; i++) {
				pips += '<i class="nwg-pip' + (pos[i][1] > 0.5 ? ' is-flip' : '') + '" style="left:' + (pos[i][0] * 100).toFixed(1) + '%;top:' + (pos[i][1] * 100).toFixed(1) + '%">' + suit + '</i>';
			}
			body = '<span class="nwg-card__pips">' + pips + '</span>';
		}

		var mark = compass ? '<img src="' + String(compass).replace(/"/g, '&quot;') + '" alt="" width="108" height="108" draggable="false">' : '';

		return '<div class="nwg-card is-down' + (red ? ' is-red' : '') + (card.r === '10' ? ' is-ten' : '') + '">' +
			'<div class="nwg-card__inner">' +
				'<div class="nwg-card__face nwg-card__front">' +
					'<span class="nwg-card__idx nwg-card__idx--tl">' + index + '</span>' +
					body +
					'<span class="nwg-card__idx nwg-card__idx--br">' + index + '</span>' +
				'</div>' +
				'<div class="nwg-card__face nwg-card__back">' + mark + '</div>' +
			'</div>' +
		'</div>';
	}

	var Core = {
		newDeck: newDeck,
		cardValue: cardValue,
		total: total,
		isBlackjack: isBlackjack,
		dealerShouldHit: dealerShouldHit,
		outcome: outcome,
		cardHTML: cardHTML
	};

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Core;
	}

	if (typeof document === 'undefined') return;

	var DAY = 24 * 60 * 60 * 1000;

	function init() {
		var root = document.getElementById('nwg-root');
		if (!root) return;

		var cfg = {
			delay: parseInt(root.getAttribute('data-delay'), 10) || 0,
			closeDays: parseInt(root.getAttribute('data-close-days'), 10) || 30,
			cooldownMs: (parseInt(root.getAttribute('data-cooldown-min'), 10) || 60) * 60 * 1000,
			code: root.getAttribute('data-code') || '',
			bonusCode: root.getAttribute('data-bonus-code') || '',
			preview: root.getAttribute('data-preview') === 'true',
			compass: root.getAttribute('data-compass') || '',
			percent: root.getAttribute('data-percent') || '',
			carAmount: root.getAttribute('data-car-amount') || '',
			bonusAmount: root.getAttribute('data-bonus-amount') || '',
			minOrder: root.getAttribute('data-min-order') || '',
			expiry: root.getAttribute('data-expiry') || '',
			emailEndpoint: root.getAttribute('data-email-endpoint') || ''
		};

		var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		var EASE = 'cubic-bezier(.2,.7,.2,1)';
		var dialog = root.querySelector('.nwg__dialog');
		var steps = root.querySelectorAll('.nwg__step');
		var form = root.querySelector('.nwg__form');
		var emailInput = root.querySelector('#nwg-email');
		var optIn = root.querySelector('#nwg-optin');
		var errorEl = root.querySelector('.nwg__error');
		var table = root.querySelector('.nwg__table');
		var playerHand = root.querySelector('.nwg__hand--player');
		var statusEl = root.querySelector('.nwg__status');
		var deckEl = root.querySelector('.nwg__deck');
		var actions = root.querySelector('.nwg__actions');
		var btnHit = root.querySelector('[data-action="hit"]');
		var btnStand = root.querySelector('[data-action="stand"]');
		var btnAgain = root.querySelector('[data-action="again"]');
		var termsModal = root.querySelector('.nwg__terms-modal');
		var canvas = root.querySelector('.nwg__confetti');
		var logForm = root.querySelector('#nwg-log-form');
		var custForm = root.querySelector('#nwg-customer-form');

		var state = { open: false, step: 'welcome', active: false, finished: false, deck: [], player: [], dealer: [], email: '', optin: false, hidden: null, busy: false, sent: { base: '', bonus: '' } };

		var store = {
			get: function (k) { try { return window.localStorage.getItem('nwg.' + k); } catch (e) { return null; } },
			set: function (k, v) { try { window.localStorage.setItem('nwg.' + k, v); } catch (e) {} }
		};
		function getJSON(k, fb) {
			try { var v = JSON.parse(store.get(k)); return v == null ? fb : v; } catch (e) { return fb; }
		}

		// Motion pauses. With reduced motion every pause is cut to a 120ms cross-fade.
		function wait(ms) {
			return new Promise(function (resolve) { setTimeout(resolve, reduced ? Math.min(ms, 120) : ms); });
		}

		// A pause that is not shortened, for holding the result on screen before the next step.
		function hold(ms) {
			return new Promise(function (resolve) { setTimeout(resolve, reduced ? Math.min(ms, 1200) : ms); });
		}

		function showStep(name) {
			state.step = name;
			for (var i = 0; i < steps.length; i++) {
				steps[i].hidden = steps[i].getAttribute('data-step') !== name;
			}
			dialog.classList.toggle('is-wide', name === 'table');
			dialog.scrollTop = 0;
		}

		function setError(msg) {
			errorEl.textContent = msg || '';
			errorEl.hidden = !msg;
		}

		function focusables() {
			var scope = termsModal && !termsModal.hidden ? termsModal : dialog;
			return Array.prototype.filter.call(
				scope.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'),
				function (el) { return el.offsetParent !== null; }
			);
		}

		function onKey(e) {
			if (!state.open) return;
			if (e.key === 'Escape') {
				if (termsModal && !termsModal.hidden) closeTerms(); else closePopup();
				return;
			}
			if (e.key === 'Tab') {
				var f = focusables();
				if (!f.length) return;
				var first = f[0], last = f[f.length - 1];
				if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
				else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
			}
		}

		function openPopup() {
			if (state.open) return;
			state.open = true;
			root.hidden = false;
			document.documentElement.classList.add('nwg-lock');
			requestAnimationFrame(function () { root.classList.add('is-open'); dialog.focus(); });
			document.addEventListener('keydown', onKey);
		}

		function hidePopup() {
			state.open = false;
			root.classList.remove('is-open');
			document.documentElement.classList.remove('nwg-lock');
			document.removeEventListener('keydown', onKey);
			setTimeout(function () { if (!state.open) root.hidden = true; }, reduced ? 0 : 220);
		}

		// The code is free, so closing only hides the popup for a short while (one day by default) for everyone.
		// After a lost hand it comes back once the cooldown ends, so they can try the optional hand again.
		function closePopup() {
			var now = Date.now();
			var until = now + cfg.closeDays * DAY;
			if (state.active && !state.finished) {
				state.finished = true;
				state.active = false;
				recordLoss();
				until = now + cfg.cooldownMs;
			} else if (state.step === 'voucher' || state.step === 'table') {
				var cooling = getJSON('cooldowns', {})[state.email];
				if (bonusMode() !== 'won' && cooling && cooling > now) until = cooling;
			}
			if (!cfg.preview) store.set('closedUntil', String(until));
			hidePopup();
		}

		function openTerms() { termsModal.hidden = false; var b = termsModal.querySelector('button'); if (b) b.focus(); }
		function closeTerms() { termsModal.hidden = true; }

		function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

		function minutesLeft(ts) { return Math.max(1, Math.ceil((ts - Date.now()) / 60000)); }

		function submitForm(f, fields) {
			if (!f) return;
			try {
				for (var k in fields) {
					var input = f.querySelector('[name="' + k + '"]');
					if (input) input.value = fields[k];
				}
				fetch(f.action, { method: 'POST', body: new FormData(f), keepalive: true, credentials: 'same-origin' }).catch(function () {});
			} catch (e) {}
		}

		var EVENTS = {
			CODE: 'CODE (claimed the welcome code)',
			WON: 'WON (beat the dealer, extra ' + cfg.bonusAmount + ' code)',
			LOST: 'LOST (lost the optional hand, no extra ' + cfg.bonusAmount + ')'
		};

		function logResult(kind) {
			var opted = state.optin ? 'yes' : 'no';
			submitForm(logForm, {
				'contact[email]': state.email,
				'contact[name]': 'Welcome promo entry',
				'contact[body]': 'Welcome promotion. Result: ' + (EVENTS[kind] || kind) + '. Marketing opt-in: ' + opted + '. Time: ' + new Date().toISOString()
			});
			if (state.optin) {
				submitForm(custForm, {
					'contact[email]': state.email,
					'contact[tags]': 'blackjack-entry, blackjack-' + kind.toLowerCase()
				});
			}
		}

		function recordLoss() {
			var cds = getJSON('cooldowns', {});
			cds[state.email] = Date.now() + cfg.cooldownMs;
			store.set('cooldowns', JSON.stringify(cds));
			if (!cfg.preview) store.set('closedUntil', String(cds[state.email]));
			logResult('LOST');
		}

		function recordWin() {
			var winners = getJSON('winners', []);
			if (winners.indexOf(state.email) === -1) winners.push(state.email);
			store.set('winners', JSON.stringify(winners));
			if (!cfg.preview) store.set('closedUntil', String(Date.now() + cfg.closeDays * DAY));
			logResult('WON');
		}

		function wrapOf(who) { return root.querySelector('[data-cards="' + who + '"]'); }

		function cardEl(card) {
			var tmp = document.createElement('div');
			tmp.innerHTML = cardHTML(card, cfg.compass);
			return tmp.firstChild;
		}

		// Keeps a hand inside the felt: normal gap when it fits, overlapping when it does not.
		function layoutHand(wrap) {
			var n = wrap.children.length;
			if (n < 2) { wrap.style.removeProperty('--nwg-ml'); return; }
			var cs = window.getComputedStyle(wrap);
			var cw = wrap.children[0].offsetWidth;
			var avail = wrap.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
			var gap = cw * 0.12;
			var ml = n * cw + (n - 1) * gap > avail ? (avail - n * cw) / (n - 1) : gap;
			wrap.style.setProperty('--nwg-ml', Math.max(ml, -cw * 0.72).toFixed(1) + 'px');
		}

		function relayout() {
			if (!state.open || state.step !== 'table') return;
			layoutHand(wrapOf('player'));
			layoutHand(wrapOf('dealer'));
		}

		function finished(anim) {
			return anim && anim.finished ? anim.finished.catch(function () {}) : wait(400);
		}

		// Deal: from the shoe to the seat, settling out of a slight rotation. 380ms.
		function flyIn(el, delay) {
			if (!el.animate) return wait(delay + 380);
			var anim;
			if (reduced) {
				anim = el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 120, fill: 'both' });
			} else {
				var to = el.getBoundingClientRect();
				var dx = 0, dy = 0;
				if (deckEl) {
					var from = deckEl.getBoundingClientRect();
					dx = (from.left + from.width / 2) - (to.left + to.width / 2);
					dy = (from.top + from.height / 2) - (to.top + to.height / 2);
				}
				anim = el.animate([
					{ transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(-14deg) scale(.7)', opacity: 0 },
					{ opacity: 1, offset: 0.15 },
					{ transform: 'none', opacity: 1 }
				], { duration: 380, delay: delay, easing: EASE, fill: 'both' });
			}
			return finished(anim).then(function () { try { anim.cancel(); } catch (e) {} });
		}

		// When a card is added the hand re-centres, so slide the cards already there to their new seats.
		function reseat(wrap, lefts) {
			if (reduced) return;
			for (var i = 0; i < lefts.length; i++) {
				var c = wrap.children[i];
				var dx = lefts[i] - c.getBoundingClientRect().left;
				if (Math.abs(dx) > 0.5 && c.animate) {
					try { c.animate([{ translate: dx + 'px 0px' }, { translate: '0px 0px' }], { duration: 380, easing: EASE }); } catch (e) {}
				}
			}
		}

		// Flip: back to front on the Y axis. 420ms.
		function flip(el) {
			el.classList.remove('is-down');
			return wait(420);
		}

		function updateScores() {
			var pScore = root.querySelector('[data-score="player"]');
			var dScore = root.querySelector('[data-score="dealer"]');
			pScore.textContent = state.player.length ? total(state.player) : '';
			if (!state.dealer.length) { dScore.textContent = ''; return; }
			dScore.textContent = state.hidden ? total(state.dealer.slice(0, 1)) + ' + ?' : String(total(state.dealer));
		}

		function deal(who, faceUp, delay, shift) {
			var card = state.deck.pop();
			state[who].push(card);
			var wrap = wrapOf(who);
			var lefts = shift ? Array.prototype.map.call(wrap.children, function (c) { return c.getBoundingClientRect().left; }) : [];
			var el = cardEl(card);
			wrap.appendChild(el);
			if (who === 'dealer' && !faceUp) state.hidden = el;
			layoutHand(wrap);
			if (shift) reseat(wrap, lefts);
			return flyIn(el, delay).then(function () {
				return faceUp ? flip(el) : null;
			}).then(updateScores);
		}

		// The hole card stays down until the player stands or busts, then flips 200ms after the turn ends.
		function revealDealer() {
			if (!state.hidden) return Promise.resolve();
			var el = state.hidden;
			state.hidden = null;
			return wait(200).then(function () { return flip(el); }).then(function () { updateScores(); return wait(80); });
		}

		function setStatus(msg, win) {
			statusEl.textContent = msg || '';
			statusEl.classList.toggle('is-win', !!win);
		}

		function setActions(mode) {
			btnHit.hidden = btnStand.hidden = mode !== 'play';
			btnAgain.hidden = mode !== 'again';
			btnHit.disabled = btnStand.disabled = false;
			actions.hidden = mode === 'none';
		}

		function startHand() {
			if (state.active && !state.finished) return Promise.resolve();
			state.deck = newDeck();
			state.player = []; state.dealer = []; state.hidden = null;
			state.active = true; state.finished = false; state.busy = true;
			table.classList.remove('is-win');
			playerHand.classList.remove('is-win');
			wrapOf('player').innerHTML = '';
			wrapOf('dealer').innerHTML = '';
			wrapOf('player').style.removeProperty('--nwg-ml');
			wrapOf('dealer').style.removeProperty('--nwg-ml');
			updateScores();
			setStatus('Dealing…');
			setActions('none');
			showStep('table');
			return wait(250).then(function () {
				// Seats are filled in order (you, dealer, you, dealer), 90ms apart.
				var order = [['player', true], ['dealer', true], ['player', true], ['dealer', false]];
				var jobs = [];
				for (var i = 0; i < order.length; i++) {
					jobs.push(deal(order[i][0], order[i][1], reduced ? 0 : i * 90, false));
				}
				return Promise.all(jobs);
			}).then(function () {
				if (isBlackjack(state.player) || isBlackjack(state.dealer)) {
					var mine = isBlackjack(state.player);
					setStatus(mine ? 'Blackjack!' : 'Dealer has blackjack.', mine && !isBlackjack(state.dealer));
					return revealDealer().then(finish);
				}
				state.busy = false;
				setStatus('Your move: Hit or Stand?');
				setActions('play');
				btnHit.focus();
			});
		}

		function hit() {
			if (state.busy || !state.active) return;
			state.busy = true;
			btnHit.disabled = btnStand.disabled = true;
			deal('player', true, 0, true).then(function () {
				var t = total(state.player);
				if (t > 21) { setStatus('Bust!'); return revealDealer().then(finish); }
				if (t === 21) { return stand(true); }
				state.busy = false;
				btnHit.disabled = btnStand.disabled = false;
				btnHit.focus();
			});
		}

		function stand(auto) {
			if (!auto && (state.busy || !state.active)) return;
			state.busy = true;
			btnHit.disabled = btnStand.disabled = true;
			setStatus('Dealer’s turn…');
			revealDealer().then(function loop() {
				if (dealerShouldHit(state.dealer)) {
					return wait(350).then(function () { return deal('dealer', true, 0, true); }).then(loop);
				}
				return finish();
			});
		}

		function finish() {
			state.active = false; state.finished = true; state.busy = false;
			var result = outcome(state.player, state.dealer);
			if (result === 'win') {
				setStatus(isBlackjack(state.player) ? 'Blackjack! You win.' : 'You beat the dealer!', true);
				playerHand.classList.add('is-win');
				recordWin();
				confetti();
				return hold(1900).then(showVoucher);
			}
			if (result === 'lose') {
				setStatus(total(state.player) > 21 ? 'Bust. Dealer wins.' : 'Dealer wins this time.');
				recordLoss();
				return hold(1700).then(showVoucher);
			}
			setStatus('Push: it’s a tie. No winner this hand.');
			setActions('again');
			btnAgain.focus();
		}

		// The optional hand: 'won' once they have beaten the dealer, 'lost' while they are cooling down, otherwise 'offer'.
		function bonusMode() {
			if (getJSON('winners', []).indexOf(state.email) !== -1) return 'won';
			var next = getJSON('cooldowns', {})[state.email];
			return next && next > Date.now() ? 'lost' : 'offer';
		}

		function renderBonus() {
			var mode = bonusMode();
			var blocks = root.querySelectorAll('[data-bonus]');
			for (var i = 0; i < blocks.length; i++) blocks[i].hidden = blocks[i].getAttribute('data-bonus') !== mode;
			if (mode === 'lost') {
				var next = getJSON('cooldowns', {})[state.email];
				root.querySelector('[data-bonus-lost-text]').textContent = 'Dealer wins this time, so no extra ' + cfg.bonusAmount + '. Your welcome voucher above still stands. You can try again in about ' + minutesLeft(next) + ' minutes.';
			}
			// After a win the email button sends both codes, so it is ready again even if the first code was already emailed.
			var btn = root.querySelector('[data-action="email"]');
			var sent = state.sent[mode === 'won' ? 'bonus' : 'base'];
			btn.disabled = !!sent;
			btn.textContent = sent || (mode === 'won' ? 'Email me my codes' : 'Email me this code');
			emailNote('');
		}

		function showVoucher() {
			root.querySelector('[data-code]').textContent = cfg.code;
			root.querySelector('[data-bonus-code-text]').textContent = cfg.bonusCode;
			renderBonus();
			showStep('voucher');
			var b = root.querySelector('[data-action="copy"]');
			if (b && state.open) b.focus();
		}

		function copyText(btn, text, label) {
			function done() { btn.textContent = 'Copied!'; setTimeout(function () { btn.textContent = label; }, 2000); }
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(done, fallback);
			} else { fallback(); }
			function fallback() {
				var ta = document.createElement('textarea');
				ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
				document.body.appendChild(ta); ta.select();
				try { document.execCommand('copy'); done(); } catch (e) {}
				document.body.removeChild(ta);
			}
		}

		function emailNote(msg) {
			var n = root.querySelector('.nwg__email-note');
			if (!n) return;
			n.textContent = msg || '';
			n.hidden = !msg;
		}

		function emailCode() {
			if (!state.email) return;
			var bonus = bonusMode() === 'won';
			var key = bonus ? 'bonus' : 'base';
			var idle = bonus ? 'Email me my codes' : 'Email me this code';
			if (!cfg.emailEndpoint) { mailtoDraft(bonus); return; }
			var btn = root.querySelector('[data-action="email"]');
			btn.disabled = true;
			btn.textContent = 'Sending…';
			emailNote('');
			fetch(cfg.emailEndpoint, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email: state.email, bonus: bonus })
			}).then(function (res) {
				if (res.ok) {
					state.sent[key] = btn.textContent = 'Email sent';
					emailNote('We’ve emailed ' + (bonus ? 'your codes' : 'your code') + ' to ' + state.email + '. If you can’t see it, check your spam folder.');
				} else if (res.status === 409) {
					state.sent[key] = btn.textContent = 'Already emailed';
					emailNote('We’ve already emailed this address. Check your inbox and spam folder.');
				} else {
					throw new Error('send failed');
				}
			}).catch(function () {
				btn.disabled = false;
				btn.textContent = idle;
				emailNote('We couldn’t send the email just now, so we’ve opened an email draft instead.');
				mailtoDraft(bonus);
			});
		}

		function mailtoDraft(bonus) {
			var lines = [
				'Your Northwest Motors voucher code: ' + cfg.code,
				'',
				'How to use it:',
				'- Online parts orders of ' + cfg.minOrder + ' or more: ' + cfg.percent + ' off. Enter the code at checkout, or include it in your "Request a Part" description before payment is made.',
				'- Cars: ' + cfg.carAmount + ' off a car, redeemed in person. Show your code before the sale is finalised.',
				'- No discounts on services. We keep our service prices as low as we can, so vouchers don’t apply to them.',
				'',
				'One use only. Expires ' + cfg.expiry + '. Can’t be combined with any other offer, other than the extra ' + cfg.bonusAmount + ' code from playing a hand.'
			];
			if (bonus) {
				lines.push('', 'Your extra ' + cfg.bonusAmount + ' code for online orders of ' + cfg.minOrder + ' or more (use it together with the code above): ' + cfg.bonusCode);
			}
			lines.push('', 'Northwest Motors - admin@northwestmotors.co.nz');
			var url = 'mailto:' + state.email + '?subject=' + encodeURIComponent('Your Northwest Motors voucher code') + '&body=' + encodeURIComponent(lines.join('\r\n'));
			var a = document.createElement('a');
			a.href = url;
			a.style.display = 'none';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		}

		// A small, sparse nod above the winning hand: navy, gold and cream only. About 1.2s, then a quick fade.
		function confetti() {
			if (reduced || !canvas || !canvas.getContext) return;
			var rect = root.getBoundingClientRect();
			var hand = wrapOf('player').getBoundingClientRect();
			var dpr = Math.min(window.devicePixelRatio || 1, 2);
			canvas.width = Math.round(rect.width * dpr);
			canvas.height = Math.round(rect.height * dpr);
			var ctx = canvas.getContext('2d');
			ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
			var ox = hand.left - rect.left + hand.width / 2;
			var oy = hand.top - rect.top + 8;
			var spread = Math.min(hand.width, 260) / 2;
			var colors = ['#0a1729', '#c9a253', '#f6f1e6'];
			var parts = [];
			for (var i = 0; i < 40; i++) {
				parts.push({
					x: ox + (Math.random() - 0.5) * spread, y: oy,
					vx: (Math.random() - 0.5) * 5.2, vy: -(2.6 + Math.random() * 4),
					w: 4 + Math.random() * 4, h: 2.5 + Math.random() * 3,
					c: colors[i % colors.length], rot: Math.random() * 6, vr: (Math.random() - 0.5) * 0.35
				});
			}
			var HOLD = 1200, FADE = 400;
			var start = performance.now();
			(function frame(now) {
				var t = now - start;
				ctx.clearRect(0, 0, rect.width, rect.height);
				var alpha = t < HOLD ? 1 : Math.max(0, 1 - (t - HOLD) / FADE);
				if (alpha > 0) {
					for (var i = 0; i < parts.length; i++) {
						var p = parts[i];
						p.vy += 0.2; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
						ctx.save();
						ctx.globalAlpha = alpha;
						ctx.translate(p.x, p.y); ctx.rotate(p.rot);
						ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
						if (p.c === '#0a1729') { ctx.strokeStyle = 'rgba(246,241,230,.45)'; ctx.lineWidth = 0.6; ctx.strokeRect(-p.w / 2, -p.h / 2, p.w, p.h); }
						ctx.restore();
					}
					requestAnimationFrame(frame);
				} else {
					ctx.clearRect(0, 0, rect.width, rect.height);
				}
			})(start);
		}

		// The email is all it takes to get the code. Returns true when the address was valid and the code is claimed.
		function claimCode() {
			var email = (emailInput.value || '').trim().toLowerCase();
			if (!validEmail(email)) { setError('Please enter a valid email address.'); emailInput.focus(); return false; }
			setError('');
			state.email = email;
			state.optin = !!(optIn && optIn.checked);
			store.set('email', email);
			store.set('claimed', '1');
			if (!cfg.preview) store.set('closedUntil', String(Date.now() + cfg.closeDays * DAY));
			var claimed = getJSON('claimedEmails', []);
			if (claimed.indexOf(email) === -1) {
				claimed.push(email);
				store.set('claimedEmails', JSON.stringify(claimed));
				logResult('CODE');
			}
			return true;
		}

		// The optional hand. Someone who has already won, or is still cooling down after a loss, just sees their voucher.
		function playHand() {
			if (bonusMode() !== 'offer') { showVoucher(); return; }
			startHand();
		}

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			if (claimCode()) showVoucher();
		});

		root.addEventListener('click', function (e) {
			var t = e.target;
			if (!t || !t.closest) return;
			if (t.closest('[data-nwg-close]')) { closePopup(); return; }
			if (t.closest('[data-nwg-terms]')) { openTerms(); return; }
			if (t.closest('[data-nwg-terms-close]')) { closeTerms(); return; }
			if (t === termsModal) { closeTerms(); return; }
			var a = t.closest('[data-action]');
			if (!a) return;
			var act = a.getAttribute('data-action');
			if (act === 'hit') hit();
			else if (act === 'stand') stand();
			else if (act === 'again') startHand();
			else if (act === 'play-welcome') { if (claimCode()) playHand(); }
			else if (act === 'play') playHand();
			else if (act === 'copy') copyText(a, cfg.code, 'Copy code');
			else if (act === 'copy-bonus') copyText(a, cfg.bonusCode, 'Copy extra code');
			else if (act === 'email') emailCode();
		});

		window.addEventListener('resize', relayout);

		var saved = store.get('email');
		if (saved && emailInput) emailInput.value = saved;

		// Have the card back ready before anyone reaches the table.
		if (cfg.compass) { var pre = new Image(); pre.src = cfg.compass; }

		if (cfg.preview) { openPopup(); return; }
		var closedUntil = parseInt(store.get('closedUntil'), 10);
		if (closedUntil && closedUntil > Date.now()) return;

		// Someone who already has their code sees it again, with the optional hand if they have not won yet.
		if (store.get('claimed') === '1' && store.get('email')) {
			state.email = store.get('email');
			showVoucher();
		}

		// The delay counts from the start of the page load, so a slow page does not push the popup back.
		var sinceStart = window.performance && performance.now ? performance.now() : 0;
		setTimeout(openPopup, Math.max(0, cfg.delay * 1000 - sinceStart));
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
	else init();
})();
